<template>
    <div>
         <draggable :list="question_details" class="py-2 cursor-move">
          <vs-card
            v-for="(question_detail, index) in question_details"
            :key="index"
            class="cstm-card mt-4 mb-0"
            style="padding: 10px"
          >
            <div v-if="question_detail.showAnswer === false">
              <!-- question setting area -->
              <vs-row vs-w="12">
                <!-- question -->
                <vs-col vs-justify="center" vs-align="top" vs-lg="6" vs-xs="12">
                  <div class="bg-grid-color flex selectable-holder w-full">
                    <!-- <vs-input class="inputx w-full mr-2" placeholder="Question" v-model="question_detail.question_title" /> -->
                    <vs-textarea
                      v-model="question_detail.question_title"
                      label="Type The Question"
                      v-validate="'required'"
                      :name="`question${index + 1}`"
                    ></vs-textarea>
                  </div>

                  <span
                    v-show="errors.has(`Questions.question${index + 1}`)"
                    class="text-danger block"
                    >{{ errors.first(`Questions.question${index + 1}`) }}</span
                  >
                </vs-col>

                <vs-col
                  class="ml-2"
                  vs-justify="center"
                  vs-align="top"
                  vs-lg="5"
                  vs-xs="12"
                >
                  <div class="bg-grid-color flex w-full">
                    <!-- {{input_field_type}} -->
                    <v-select
                      class="cstm-select w-full"
                      v-validate="'required'"
                      :options="input_field_type"
                      label="label"
                      v-model="question_detail.input_type_id_obj"
                      @input="changeType(question_detail)"
                      :clearable="false"
                      :name="`input_type_id_obj${index}`"
                      :data-vv-name="`input_type_id_obj${index}`"
                      placeholder="Select Question Type"
                    ></v-select>
                  </div>
                  <span
                    v-show="errors.has(`Questions.input_type_id_obj${index}`)"
                    class="text-danger block"
                    >{{
                      errors.first(`Questions.input_type_id_obj${index}`)
                    }}</span
                  >
                </vs-col>
                <!-- end of question -->
              </vs-row>
              <vs-divider />
              <!-- End of FileUpload on question type file upload selected -->

              <!-- mcq options area -->
              <div
                class="options-holder"
                v-if="
                  question_detail.input_type_id_obj.field_type === 'radio' ||
                  question_detail.input_type_id_obj.field_type === 'checkbox' ||
                  question_detail.input_type_id_obj.field_type === 'select' ||
                  question_detail.input_type_id_obj.field_type === 'multiselect'
                "
              >
                <draggable
                  :list="question_detail.option"
                  class="py-2 cursor-move"
                >
                  <div
                    class="w-full mb-4"
                    v-for="(eachOption, index) in question_detail.option"
                    :key="index"
                  >
                    <!-- {{option_name}} -->
                    <div class="flex w-full">
                      <vs-input
                        class="inputx w-full mr-2"
                        placeholder="Question"
                        v-model="eachOption.option_name"
                      />
                
                      <vs-button
                        color="danger"
                        type="filled"
                        icon-pack="feather"
                        icon="icon-x"
                        @click.prevent="removeOption(question_detail, index)"
                      ></vs-button>
                    </div>
                  </div>
                </draggable>

                <div class="vx-col sm:w-1/2 w-full mb-4">
                  <a
                    class="text-primary font-bold text-sm cursor-pointer"
                    @click.prevent="addnewOptions(question_detail)"
                    >Add Another Option</a
                  >
                </div>
              </div>
              <!-- end of mcq options area -->
              <vs-row>
                <vs-col
                  vs-type="flex"
                  vs-align="center"
                  vs-lg="6"
                  vs-xs="12"
                  v-if="assignment_type != 'Report' && assignment_type != '3'"
                >
                  <a
                    class="cstm-primary-anchor cursor-pointer"
                    @click.prevent="toggleAnswer(question_detail)"
                  >
                    <svg
                      id="Layer_1"
                      data-name="Layer 1"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 19.84 24.82"
                    >
                      <rect
                        class="cls-1"
                        x="1"
                        y="4.92"
                        width="17.84"
                        height="18.89"
                      />
                      <path
                        class="cls-1"
                        d="M8.85,4.06a3.88,3.88,0,1,1,7.76,0"
                        transform="translate(-2.81 0.82)"
                      />
                      <line
                        class="cls-1"
                        x1="4.79"
                        y1="19.62"
                        x2="15.08"
                        y2="19.62"
                      />
                      <polyline
                        class="cls-1"
                        points="6.04 12.53 8.39 15.96 15.05 10.7"
                      />
                    </svg>
                    <span class="ml-2 font-bold">Answer Key</span>
                  </a>
                  <div class="num-holder">
                    Point {{ question_detail.point }}
                  </div>
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="flex-end"
                  vs-align="center"
                  vs-lg="12"
                  vs-xs="12"
                >
                  <div class="cstm-action-holder">
                    <vs-tooltip
                      text="Duplicate Question"
                      class="option-tooltip"
                    >
                      <a
                        class="cursor-pointer"
                        @click="duplicate(question_detail)"
                      >
                        <svg
                          id="Layer_1"
                          data-name="Layer 1"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 19.75 23.95"
                        >
                          <rect
                            class="cls-1"
                            x="5.32"
                            y="1"
                            width="13.43"
                            height="17.5"
                          />
                          <polyline
                            class="cls-1"
                            points="1 8.95 1 22.95 11.91 22.95"
                          />
                        </svg>
                      </a>
                    </vs-tooltip>

                    <!------------ File Upload Icon Start ------------>
                    <!-- Image Upload -->
                    <vs-tooltip text="Upload Image" class="option-tooltip">
                      <a
                        class="cursor-pointer"
                        @click="
                          question_detail.showFileUpload = true;
                          question_detail.showLinkUpload = false;
                          question_detail.acceptedfileUploadType = 'image/*';
                          question_detail.fileUploadHelpText = 'Choose Image files';
                        "
                      >
                        <svg
                          class="cls-1"
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#000000"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <rect
                            class="cls-1"
                            x="3"
                            y="3"
                            width="18"
                            height="18"
                            rx="2"
                          />
                          <circle cx="8.5" cy="8.5" r="1.5" />
                          <path d="M20.4 14.5L16 10 4 20" />
                        </svg>
                      </a>
                    </vs-tooltip>

                    <!-- Video Upload -->
                    <vs-tooltip
                      text="Upload Audio/Video"
                      class="option-tooltip"
                    >
                      <a
                        class="cursor-pointer"
                        @click="
                          question_detail.showFileUpload = true;
                          question_detail.showLinkUpload = false;
                          question_detail.acceptedfileUploadType = 'audio/*,video/*';
                          question_detail.fileUploadHelpText = 'Choose Audio/Video files';
                        "
                      >
                        <svg
                          class="cls-1"
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#000000"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <path
                            d="M15.6 11.6L22 7v10l-6.4-4.5v-1zM4 5h9a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7c0-1.1.9-2 2-2z"
                          />
                        </svg>
                      </a>
                    </vs-tooltip>

                    <!-- File Attachment -->
                    <vs-tooltip text="File Attachment" class="option-tooltip">
                      <a
                        class="cursor-pointer"
                        @click="
                          question_detail.showFileUpload = true;
                          question_detail.showLinkUpload = false;
                          question_detail.acceptedfileUploadType = '*';
                          question_detail.fileUploadHelpText = 'Choose Any files';
                        "
                      >
                        <svg
                          class="cls-1"
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#000000"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <path
                            d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"
                          ></path>
                        </svg>
                      </a>
                    </vs-tooltip>
                    <!---------- File Upload Icon End ------------>

                    <!---------- Link Upload Icon Start ------------>
                    <vs-tooltip text="Add Links" class="option-tooltip">
                      <a
                        class="cursor-pointer"
                        @click="
                          question_detail.showFileUpload = false;
                          question_detail.showLinkUpload = !showLinkUpload;
                        "
                      >
                        <svg
                          class="cls-1"
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#000000"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <path
                            d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
                          ></path>
                          <path
                            d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
                          ></path>
                        </svg>
                      </a>
                    </vs-tooltip>
                    <!---------- Link Upload Icon End ------------>

                    <!-- <pre> {{question_detail}}</pre> -->
                    <vs-tooltip text="Delete Question" class="option-tooltip">
                      <a
                        v-if="question_detail.id"
                        class="cursor-pointer"
                        @click="deleteQuestionById(question_detail.id, index)"
                      >
                        <svg
                          id="Layer_1"
                          data-name="Layer 1"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 21.78 23.98"
                        >
                          <polyline
                            class="cls-1"
                            points="1 5.4 3.2 5.4 20.78 5.4"
                          />
                          <path
                            class="cls-1"
                            d="M18.8,4.42V19.8A2.19,2.19,0,0,1,16.6,22h-11a2.19,2.19,0,0,1-2.19-2.2V4.42m3.29,0V2.22A2.2,2.2,0,0,1,8.91,0h4.4a2.2,2.2,0,0,1,2.2,2.2v2.2"
                            transform="translate(-0.22 0.98)"
                          />
                          <line
                            class="cls-1"
                            x1="8.69"
                            y1="10.89"
                            x2="8.69"
                            y2="17.48"
                          />
                          <line
                            class="cls-1"
                            x1="13.09"
                            y1="10.89"
                            x2="13.09"
                            y2="17.48"
                          />
                        </svg>
                      </a>

                      <a
                        v-else
                        class="cursor-pointer"
                        @click="deleteQuestion(index)"
                      >
                        <svg
                          id="Layer_1"
                          data-name="Layer 1"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 21.78 23.98"
                        >
                          <polyline
                            class="cls-1"
                            points="1 5.4 3.2 5.4 20.78 5.4"
                          />
                          <path
                            class="cls-1"
                            d="M18.8,4.42V19.8A2.19,2.19,0,0,1,16.6,22h-11a2.19,2.19,0,0,1-2.19-2.2V4.42m3.29,0V2.22A2.2,2.2,0,0,1,8.91,0h4.4a2.2,2.2,0,0,1,2.2,2.2v2.2"
                            transform="translate(-0.22 0.98)"
                          />
                          <line
                            class="cls-1"
                            x1="8.69"
                            y1="10.89"
                            x2="8.69"
                            y2="17.48"
                          />
                          <line
                            class="cls-1"
                            x1="13.09"
                            y1="10.89"
                            x2="13.09"
                            y2="17.48"
                          />
                        </svg>
                      </a>
                    </vs-tooltip>
                  </div>
                </vs-col>
              </vs-row>

              <vs-row v-if="question_detail.showFileUpload">
                <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12">
                  <vs-divider />
                  <VueFileAgentComponent
                    :acceptedfileUploadType="question_detail.acceptedfileUploadType"
                    :question_detail_obj="question_detail"
                    :question_detail_index="index"
                    :helpText="question_detail.fileUploadHelpText"
                    @getFileId="getIdFile"
                    @hideFileUploader="question_detail.showFileUpload = false"
                    :file_repository_id="repository_id"
                    :filesInfo="question_detail.filesInfo"
                  >
                  </VueFileAgentComponent>
                </vs-col>
                <vs-divider
                  v-if="assignment_type != 'Q&A' && assignment_type != '1'"
                />
              </vs-row>
              <vs-row v-if="question_detail.showLinkUpload">
                <vs-divider />
                <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12">
                  <LinkPreviewComponent
                    :question_detail="question_detail"
                    type="Create-Edit"
                    @removeLinkEvent="removeLink"
                  >
                  </LinkPreviewComponent>
                  <vs-divider />
                  <vs-button
                    color="primary"
                    type="filled"
                    icon="add"
                    @click="addAnotherLink(question_detail)"
                  >
                    <span>Add Another Link</span>
                  </vs-button>
                </vs-col>
                <vs-divider
                  v-if="assignment_type != 'Q&A' && assignment_type != '1'"
                />
              </vs-row>

              <!-- end of question setting area -->
            </div>

            <!-- end of add question form -->
            <!-- answer block -->
            <div class="mt-5" v-else>
              <h4 class="flex items-center">
                <svg
                  id="Layer_1"
                  data-name="Layer 1"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 19.84 24.82"
                >
                  <rect
                    x="1"
                    y="4.92"
                    width="17.84"
                    height="18.89"
                    class="cls-1"
                  ></rect>
                  <path
                    d="M8.85,4.06a3.88,3.88,0,1,1,7.76,0"
                    transform="translate(-2.81 0.82)"
                    class="cls-1"
                  ></path>
                  <line
                    x1="4.79"
                    y1="19.62"
                    x2="15.08"
                    y2="19.62"
                    class="cls-1"
                  ></line>
                  <polyline
                    points="6.04 12.53 8.39 15.96 15.05 10.7"
                    class="cls-1"
                  ></polyline>
                </svg>
                <span class="ml-3">Choose correct answer</span>
              </h4>
              <vs-divider />
              <vs-row>
                <vs-col vs-type="flex" vs-align="center" vs-w="12">
                  <h5>{{ question_detail.question_title }}</h5>
                </vs-col>

                <vs-divider v-if="question_detail.question_title !== ''" />
                <vs-col vs-type="flex" vs-align="center" vs-w="12">
                  <!-- {{ question_detail.point }} -->
                  <vs-input-number
                    type="text"
                    v-model="question_detail.point"
                    v-validate="'required|numeric'"
                    name="marks"
                    data-vv-name="marks"
                  />
                  <span class="ml-2">Points</span>
                  <span
                    v-show="errors.has('Questions.marks')"
                    class="text-danger block"
                    >{{ errors.first("Questions.marks") }}</span
                  >
                  <br />
                  <!-- {{question_detail.marks}} -->
                </vs-col>
              </vs-row>
              <!-- {{question_detail.option}}
               {{question_detail.answer}} -->
              <div>
                <div
                  class="answer-holder mt-4"
                  v-for="(dynamicarray, counter) in question_detail.option"
                  :key="counter"
                >
                  <vs-checkbox
                    v-if="
                      question_detail.input_type_id_obj.field_type ===
                        'multiselect' ||
                      question_detail.input_type_id_obj.field_type ===
                        'checkbox'
                    "
                    v-validate="'required'"
                    data-vv-name="answer_select"
                    name="answer_select"
                    class="mx-4 w-full"
                    v-model="dynamicarray.is_answer"
                  >
                    {{ dynamicarray.option_name }}
                  </vs-checkbox>

                  <vs-checkbox
                    v-if="
                      question_detail.input_type_id_obj.field_type ===
                        'radio' ||
                      question_detail.input_type_id_obj.field_type === 'select'
                    "
                    :disabled="dynamicarray.is_answer == true"
                    @change="
                      setDynamicRadioTrue(question_detail.option, counter)
                    "
                    :vs-value="dynamicarray.is_answer === 1"
                    v-model="dynamicarray.is_answer"
                  >
                    {{ dynamicarray.option_name }}</vs-checkbox
                  >

                  <!-- {{question_detail}} -->
                  <!-- {{index}} -->
                  <span
                    v-show="errors.has('Questions.answer_select')"
                    class="text-danger block"
                    >{{ errors.first("Questions.answer_select") }}</span
                  >
                  <!-- {{question_detail.answer.includes(dynamicarray) }} -->
                  <!-- {{ question_detail.answer }} -->
                </div>
              </div>
              <div
                v-if="
                  question_detail.input_type_id_obj.field_type ===
                    'short-answer' ||
                  question_detail.input_type_id_obj.field_type ===
                    'paragraph' ||
                  question_detail.input_type_id_obj.field_type === 'paragraph'
                "
              >
                <vs-textarea
                  label="answer"
                  v-model="question_detail.answer"
                  placeholder="Enter Answer"
                  height="200"
                ></vs-textarea>
              </div>
              <vs-textarea
                class="mt-4"
                height="100px"
                v-model="question_detail.answerfeedback"
                placeholder="Feedback"
              />
              <vs-divider />
              <div class="text-right">
                <vs-button @click.prevent="setShowAnswerFalse(question_detail)"
                  >Done</vs-button
                >
              </div>
            </div>

            <!-- {{question_detail.save_question_bank}} -->

            <vs-checkbox
              v-model="question_detail.save_question_bank"
              v-if="assignment_type != 'Q&A' && assignment_type != '1'"
              >Save this to Question bank</vs-checkbox
            >

            <!-- <vs-button class="ml-2" type="filled">Save</vs-button> -->
          </vs-card>
        </draggable>

    </div>
</template>

<script>
export default {
  props:{
    value:{
      type:Array,
      required:true,
      default:() => {}
    },
    assignment_type:{},
    repository_id:{}
  },
  computed:{
    question_detail:{
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>